import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ComponentContainer from '../../components/component-container/ComponentContainer';
import imgSignatureLoader from '../../images/img_signature_loader.svg';
import imgDocumentToSign from '../../images/img_documents_to_sign.svg';
import { AuthContext } from '../../components/auth-context/auth-context';
import { Button } from '@/components/ui/button';
import './Landing.css';

const Landing = () => {
	const authCtx = useContext(AuthContext);
	const history = useHistory();

	return (
		<ComponentContainer>
			<div className="box">
				<div className="part-1">
					<h1>Bienvenido a CyberSign</h1>
					<br />
					<p>Firmar documentos nunca fue tan fácil</p>
				</div>

				<div className="part-2">
					<div className="cyber-signature-loader">
						<div className="cyber-signature-loader__documents">
							<img
								className="landingImg"
								src={imgDocumentToSign}
								alt=""
							/>
						</div>
						<div className="cyber-signature-loader__sign landingImgSignature">
							<img className="" src={imgSignatureLoader} alt="" />
						</div>
					</div>
				</div>
			</div>
			{authCtx.isAuthenticated ? null : (
				<Button onClick={() => history.push('/login')}>Login</Button>
			)}
		</ComponentContainer>
	);
};

export default Landing;
